import { ContactDto, ContactType, ContactTypes } from '@ch-apptitude-icc/lablink/shared/entities';
import { FormikEntityWrapper } from '@common/frontend/components/ui-forms/FormikEntityWrapper';
import { Button, FormikElementWrapper, Select, TextArea } from '@features/ui/components';
import { showToast } from '@features/ui/services/showToast';
import { useApi } from '@services/api';
import { Form, FormikHelpers } from 'formik';
import { useTranslation } from 'next-i18next';

type ContactsFormValues = Omit<ContactDto, 'type'> & { type: ContactType | '' };

export const ContactsForm = (): JSX.Element => {
  const { t } = useTranslation('common');
  const { contactApi } = useApi();
  const useContact = contactApi.useContact();

  const onSubmit = (values: ContactsFormValues, helpers: FormikHelpers<ContactsFormValues>) => {
    useContact.mutate(values as ContactDto, {
      onSuccess: () => {
        showToast({ title: t('pages.contacts.success'), variant: 'success' });
        helpers.resetForm();
      },
    });
  };

  return (
    <FormikEntityWrapper<ContactsFormValues>
      type={ContactDto}
      initialValues={{ type: 'askForInfo', message: '', requestCopy: false }}
      onSubmit={onSubmit}
    >
      <Form>
        <div className="grid grid-cols-2 gap-y-5">
          <FormikElementWrapper<ContactsFormValues>
            label={t('pages.contacts.subject')}
            name="type"
            className="col-span-2 sm:col-span-1"
          >
            <Select
              options={ContactTypes.map(reason => ({ label: t(`pages.contacts.subjects.${reason}`), value: reason }))}
            />
          </FormikElementWrapper>
          <FormikElementWrapper<ContactsFormValues>
            label={t('pages.contacts.yourMessage')}
            name="message"
            className="col-span-2"
          >
            <TextArea rows={6} resize="vertical" />
          </FormikElementWrapper>
        </div>

        <Button
          className="mt-5"
          label={t('pages.contacts.send')}
          leftIcon="paperPlaneTop"
          loading={useContact.isLoading}
          type="submit"
        />
      </Form>
    </FormikEntityWrapper>
  );
};
